"use strict";
require('../bootstrap');
require('../plugins');
require('select2');
// require('bootstrap-datepicker');
// Pages
require('./Init');
require('./pages/index');
require('./Account');
require('./Registration');
// React
if (window.location.pathname == '/reporting')
    require('../react/Index');
